document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const targets = document.querySelectorAll([
    '.business-card',
    '.collection-showcase .product-card',
    '.home-buy-card',
    '.product-detail-story-card',
    '.product-gallery',
    '.product-detail-video-media',
    '.product-detail-banner',
    '.product-scene-carousel',
    '.acoustic-editorial-image',
    '.acoustic-highlight-grid article',
    '.faq-list details',
    '.product-recommendations'
  ].join(','));
  if (!targets.length || !('IntersectionObserver' in window)) return;
  targets.forEach((target, index) => {
    target.dataset.reveal = '';
    if (target.matches('.product-gallery, .product-detail-video-media, .product-detail-banner, .product-scene-carousel, .acoustic-editorial-image, .product-detail-story-card, .home-buy-card')) {
      target.dataset.revealDirection = index % 2 === 0 ? 'left' : 'right';
    }
    target.style.setProperty('--reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
  });
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  targets.forEach((target) => observer.observe(target));
});